import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M83.92 8.85a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m107.19 33.9 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94c-.59-.59-1.54-.59-2.12 0a1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#0597A3"
      d="M108.57 77.26a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="M38.16 103.67h-5.57V98.1c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M38.07 14.85c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M51.01 88H65v6c0 .5-.5 1-1 1H52c-.5 0-1-.5-1-1v-6z"
    />
    <path
      fill="#0597A3"
      d="M49.022 88C47.302 88 46 86.577 46 85v-8h24v8c0 1.577-1.269 3-2.978 3z"
    />
    <path
      fill="#00D8D8"
      d="M79.053 49.008C74.183 34.01 58.699 34.04 58.699 34.04L57.383 34s-15.482-.03-20.353 14.959C32.18 63.878 46.035 77 46.035 77h24c.84-.784 13.702-13.55 9.008-28.002z"
    />
    <path
      fill="#001A43"
      d="M57.84 25.62c-1.24 0-2.25-1.01-2.25-2.25v-8.78c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v8.78c0 1.24-1.01 2.25-2.25 2.25M81.13 35.71c-.58 0-1.15-.22-1.59-.66-.88-.88-.88-2.3 0-3.18l6.21-6.21c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18l-6.21 6.21c-.44.44-1.01.66-1.59.66M98.53 57.63h-8.78c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h8.78c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M87.65 87.03c-.58 0-1.15-.22-1.59-.66l-6.21-6.21c-.88-.88-.88-2.3 0-3.18s2.3-.88 3.18 0l6.21 6.21c.88.88.88 2.3 0 3.18-.44.44-1.01.66-1.59.66M35.32 35.1c-.58 0-1.15-.22-1.59-.66l-6.21-6.21c-.88-.88-.88-2.3 0-3.18s2.3-.88 3.18 0l6.21 6.21a2.25 2.25 0 0 1-1.59 3.84M26.03 57.63h-8.78c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h8.78c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M28.31 87.34c-.58 0-1.15-.22-1.59-.66-.88-.88-.88-2.3 0-3.18l6.21-6.21c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18l-6.21 6.21c-.44.44-1.02.66-1.59.66"
    />
  </svg>
);
const SvgEnrichedIconIdeaInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconIdeaInverted);
export default Memo;
